import { api } from './client';

export type AssuntoContato = 'duvida' | 'comercial' | 'suporte' | 'parceria' | 'outro';

export interface ContatoRequest {
  nome: string;
  email: string;
  telefone?: string;
  assunto: AssuntoContato;
  mensagem: string;
}

export interface ContatoResponse {
  ok: boolean;
  mensagem: string;
}

export async function enviarContato(payload: ContatoRequest): Promise<ContatoResponse> {
  const { data } = await api.post<ContatoResponse>('/contato', payload);
  return data;
}
